// extracted by mini-css-extract-plugin
export default {"form":"AuthForm_form__Erh-L","actions":"AuthForm_actions__plbo7"};